<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Urlopy moich pracowników </span>
        <h3 class="page-title">
          <template>Urlop pracownika:
            <div v-for="(user, index) in users" :key="index" v-if="user.id === data.user_id" >
              <p class="mt-2" style="font-weight: 100">{{user.name + ' ' + user.last_name}}
              </p>
            </div>
          </template>
        </h3>
      </d-col>
      <d-col
        col
        sm="6"
        class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          v-if="data.user_id"
          @click.prevent="backToList()"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          Wróć do listy
        </d-button>
        <d-dropdown
          class="dropdownStatus"
          v-if="(data.status === 'NEW') && (userData.role !== 'R_HR') && (userData.role !== 'R_RECEPTION')"
          :theme="data.status === 'NEW' ? 'secondary' : ( data.status === 'ACCEPTED' ? 'success' : ( data.status === 'REJECTED' ? 'danger' : 'warning'))"
          :menu-id="`dropdown-${data.id}`"
          :text="data.status !== 'ACCEPTED' && data.status !== 'REJECTED' ?
              (data.status === 'NEW' ? 'Dodaj status' : 'Anulowany') : (data.status === 'ACCEPTED' ? 'Zaakceptowany' : 'Odrzucony')">
          <d-dropdown-item>
            <d-button
              :disabled="data.status !== 'NEW'"
              style="width: 100%"
              theme="success"
              @click="handleAccepted('ACCEPTED')">
              Zaakceptuj
            </d-button>
          </d-dropdown-item>
          <d-dropdown-item>
            <d-button
              :disabled="data.status !== 'NEW'"
              style="width: 100%"
              theme="danger"
              @click="handleRejected('REJECTED')">
              Odrzuć
            </d-button>
          </d-dropdown-item>
        </d-dropdown>
        <d-modal
          v-if="showAccepted || showRejected"
          @close="handleClose('NEW')"
          style="background-color: rgba(0,0,0,0.6)!important;">
          <d-modal-header>
            <d-modal-title class="mt-3 mb-3">
              {{showAccepted ? 'Potwierdzasz akceptację urlopu ?' : 'Potwierdzasz odrzucenie urlopu ?'}}
            </d-modal-title>
          </d-modal-header>
          <d-modal-body>
            <div class="form-group">
              <label for="boss_description">
                Dodaj adnotacje:
              </label>
              <validation-provider
                name="description"
                v-slot="{ errors }">
                <d-form-textarea
                  :state="errors.length ? 'invalid' : null"
                  ::autocomplete="data"
                  v-model="data.boss_description" />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
            <div class="popup-box-buttons">
              <d-button
                theme="success"
                class="text-nowrap"
                @click.prevent="submitForm(showAccepted ? 'ACCEPTED' : 'REJECTED')">
                Potwierdź
              </d-button>
              <d-button
                theme="secondary"
                class="text-nowrap ml-3"
                @click.prevent="handleClose('NEW')">
                Anuluj
              </d-button>
            </div>
          </d-modal-body>
        </d-modal>
      </d-col>
    </d-row>
    <!-- Form -->
    <d-form>
      <d-card class="mb-5">
        <d-tabs card>
          <!-- Dane ogólne -->
          <d-tab title="Dane ogólne" active>
            <h4 class="mb-3 pb-3 border-bottom">
              Dane ogólne
            </h4>
            <div class="form-control">
              <div class="form-group mt-4">
                <label style="font-weight: 600">
                  Status urlopu:
                </label>
                <d-badge
                  outline :theme="data.status === 'NEW' ? 'info': (data.status === 'ACCEPTED' ? 'success' :
                (data.status === 'CANCELLED' ? 'warning' : 'danger'))" >
                  {{ data.status === 'ACCEPTED' ? 'Zaakceptowany' : (data.status === 'REJECTED' ? 'Odrzucony' :
                  (data.status === 'NEW' ? 'Oczekuje akceptacji' : 'Anulowany')) }}
                </d-badge>
              </div>
              <div class="form-group">
                <label style="font-weight: 600">
                  Typ urlopu:
                </label>
                <p class="simpleText">
                  {{data.type_name}}
                </p>
              </div>
              <div class="form-group" v-if="data.plan_id !== null">
                <label style="font-weight: 600">
                  Zgodność z planem urlopowym:
                </label>
                <p class="simpleText">
                  {{ data.plan_id > 0 ? 'Tak' : (data.plan_id === 0 ? 'Nie' : '')  }}
                </p>
              </div>
              <div class="form-group">
                <label style="font-weight: 600">
                  Urlop od:
                </label>
                <p class="simpleText">
                  {{data.date_start}}
                </p>
              </div>
              <div class="form-group">
                <label style="font-weight: 600">
                  Urlop do:
                </label>
                <p class="simpleText">
                  {{data.date_end}}
                </p>
              </div>
              <div class="form-group">
                <label style="font-weight: 600">
                  {{ data.employment_type !== 'E_PART_TIME' ? 'Dni urlopu:' : 'Liczba godzin urlopu:' }}
                </label>
                <p class="simpleText">
                  {{data.hours}} {{ data.employment_type !== 'E_PART_TIME' ? 'dni' : 'godzin' }}
                </p>
              </div>
              <div class="form-group">
                <label style="font-weight: 600">
                  Do wykorzystania pozostało:
                </label>
                <p class="simpleText">
                  {{data.hours_available}} {{ data.employment_type !== 'E_PART_TIME' ? 'dni' : 'godzin' }}
                </p>
              </div>
              <div class="form-group">
                <label style="font-weight: 600">
                  Uwagi pracownika:
                </label>
                <p class="simpleText">
                  {{data.user_description ? data.user_description : 'brak'}}
                </p>
              </div>
            </div>
            <div
              class="form-control mt-3"
              v-if="data.boss_description"
              :style="data.status === 'ACCEPTED' ? 'border-color: #17c671' : (data.status === 'REJECTED' ? 'border-color: #c4183c' : '')">
              <div class="form-group mt-4">
                <label style="font-weight: 600">
                  Moja adnotacja:
                </label>
                <p class="simpleText">
                  {{data.boss_description ? data.boss_description : 'brak'}}
                </p>
              </div>
            </div>
            <div v-if="!allDataLoaded" class="pb-3 pt-3 text-center">
              Trwa ładowanie danych&hellip;
            </div>

            <d-alert
              v-if="loadError"
              show
              theme="warning">
              Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
            </d-alert>
          </d-tab>
        </d-tabs>
      </d-card>
    </d-form>
  </d-container>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'holidays-form',
  computed: {
    allDataLoaded () {
      return this.loaded && this.loadedHolidays;
    },
    userData () {
      return this.$store.getters.getAccount
    }
  },
  data() {
    return {
      data: {
        status: 'NEW',
        boss_description: '',
        employment_type: ''
      },
      loaded: false,
      loadError: false,
      showAccepted: false,
      showRejected: false,
      holidays: [],
      users: [],
      range: '',
      loadedHolidays: false,
    };
  },
  mounted () {
    this.loadItemData();
    this.loadAdditionalData();
    this.userAccountGet();
    this.getUsersList();
  },
  methods: {
    getUsersList () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/users/items',
        outputKey: 'users',
      });
    },
    userAccountGet () {
      this.$store.dispatch('userAccountGet')
    },
    handleClose(status) {
      this.showAccepted = false;
      this.showRejected = false;
      this.data.status = status
    },
    handleAccepted(status) {
      this.showAccepted = true;
      this.data.status = status
    },
    handleRejected(status) {
      this.showRejected = true;
      this.data.status = status
    },
    loadItemData () {
      FormUtils.loadItemData(this, {
        endpointBase: '/holidays/item/',
        instanceFields: ['type_id', 'type_name', 'date_start', 'date_end', 'status', 'hours', 'hours_available', 'user_description', 'boss_description', 'plan_id', 'employment_type', 'user_id'],
        loadedKey: 'loaded'
      });
    },
    loadAdditionalData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/holidays/children-items',
        params: {
          pagination: false
        },
        outputKey: 'holidays',
        loadedKey: 'loadedHolidays',
        errorKey: 'loadError',
      });
    },
    submitForm () {
      let formDataToSend = this.prepareFormDataToSend();
      let endpointUrl = '/holidays/update-status/' + this.id;
      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano urlop',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacja urlopu nie powiodła się. Spróbuj ponownie.',
        successAction: () => {
          this.$router.push('/urlopy-pracownikow')
        }
      });
    },
    prepareFormDataToSend () {
      return {
        status: this.data.status,
        boss_description: this.data.boss_description,
      };
    },
    backToList() {
      if (this.data.user_id) {
        if (this.$router.currentRoute.query.back === 'userItem') {
          this.$router.push('/uzytkownicy/edycja/' + this.data.user_id);
        } else {
          this.$router.push('/urlopy-pracownikow');
        }
      }
    }
  }
};
</script>
<style lang="scss">
  @import '../../assets/scss/variables/mixins.scss';
  .popup-box-buttons {
    @include popupButtons
  }
  @import "../../assets/scss/layout/holidays-children.scss";
</style>
